import { PageProps } from 'gatsby';
import { Layout } from 'components/layout/Layout';
import { LoadingLayout } from 'components/layout/LoadingLayout';
import { ArchiveLayout } from 'components/layout/ArchiveLayout';
import { useFileData } from 'services/api/Results';

export const ResultsLayout = (props: PageProps) => {
    const { data: fileData, isLoading: isFileLoading } = useFileData();
    const { isLoading: isParentLoading } = useFileData({ dataId: fileData?.parent_data_id ?? null });
    const isLoading = isFileLoading || isParentLoading;
    const filesInArchive = fileData?.extracted_files?.files_in_archive;

    const isArchive = fileData?.parent_data_id || (Array.isArray(filesInArchive) && filesInArchive.length > 0);

    if (isLoading) {
        return <LoadingLayout {...props} />;
    }

    if (isArchive) {
        return <ArchiveLayout {...props} />;
    }

    return <Layout {...props} />;
};
